<template>
	<div class="single-page" v-if="currentPage">
		<section class="page-header bg-light">
			<div class="main-content">
				<div class="title-line">
					<h1 v-html="currentPage.title.rendered"></h1>
				</div>
			</div>
		</section>
		<section class="main-content" v-if="currentPage.acf.content" >
			<DynamicHtml :html="currentPage.acf.content" />
			<div v-if="currentPage.acf.employee_list && currentPage.acf.employee_section.employees" class="employees-section">
				<div class="employee-list">
					<h3 v-html="currentPage.acf.employee_section.heading"></h3>
					<employeeList :data="currentPage.acf.employee_section.employees" type="employees" />
					<DynamicHtml v-if="currentPage.acf.employee_section.content" :html="currentPage.acf.employee_section.content" />
				</div>
			</div>
		</section>
	</div>
	<div v-else class="nothing single-page"></div>
</template>

<script>

import employeeList from '@/components/modules/EmployeeList'

export default {
	name: 'single-page',
	components: {
		employeeList
	},
	data(){
		return {
			type: null
		}
	},
	computed:{
		
	}
}
</script>
